import { DateColumn } from "../cells/DateColumn";
import ContentFeedType from "../cells/ContentFeeds/ContentFeedType";
import ContentFeedItems from "../cells/ContentFeeds/ContentFeedItems";
import ContentFeedAssignedCreatives from "../cells/ContentFeeds/ContentFeedAssignedCreatives";
import ContentFeedAutoUpdates from "../cells/ContentFeeds/ContentFeedAutoUpdates";
import { ContentFeedActionsCell } from "../cells/ContentFeeds/ContentFeedActions";
import LastUpdatedCell from "../cells/ContentFeeds/LastUpdatedCell";

const CONTENT_FEED_NAME = {
	key: "name",
	name: "Name",
	cellClass: "content-feed-name-cell",
	width: 300,
	sortable: true,
	resizable: true,
	locked: true,
};

const CONTENT_FEED_ID = {
	key: "id",
	name: "ID",
	width: 85,
	sortable: true,
	resizable: false,
	locked: true,
};

const CONTENT_FEED_TYPE = {
	key: "format",
	name: "Type",
	width: 180,
	sortable: true,
	resizable: true,
	formatter: ContentFeedType,
	getRowMetaData(data) {
		return {
			url: data.url,
			format: data.format,
			itemKey: data.itemKey,
		};
	},
};

const CONTENT_FEED_ITEMS = {
	key: "eligibleItems",
	name: "Items",
	width: 100,
	sortable: true,
	resizable: false,
	formatter: ContentFeedItems,
	getRowMetaData(data) {
		return {
			eligibleItems: data.eligibleItems,
			totalItems: data.totalItems,
		};
	},
};

const CONTENT_FEED_LAST_UPDATED = {
	key: "lastSync",
	name: "Last Updated",
	width: 200,
	sortable: true,
	resizable: true,
	formatter: LastUpdatedCell,
	getRowMetaData(data) {
		return {
			lastUpdateStatus: data.lastRun?.lastUpdateStatus,
			contentFeedId: data.id,
			contentFeedName: data.name,
			libraryId: data.libraryId,
		};
	},
};

const CONTENT_FEED_CREATED = {
	key: "created",
	name: "Creation Time",
	width: 200,
	sortable: true,
	resizable: true,
	formatter: DateColumn,
};

const CONTENT_FEED_ASSIGNED_CREATIVES = {
	key: "assignedCreatives",
	name: "Assigned Creatives",
	width: 220,
	sortable: false,
	resizable: true,
	formatter: ContentFeedAssignedCreatives,
	getRowMetaData(data) {
		return {
			creativeCount: data.creativeCount || 0,
			contentFeedName: data.name,
			contentFeedId: data.id,
			libraryId: data.libraryId,
		};
	},
};

const CONTENT_FEED_AUTO_UPDATES = {
	key: "autoUpdate",
	name: "Auto Updates",
	sortable: true,
	resizable: false,
	formatter: ContentFeedAutoUpdates,
	getRowMetaData(data) {
		return {
			contentFeedId: data.id,
			contentFeedName: data.name,
			autoUpdateEnabled: data.autoUpdate,
			libraryId: data.libraryId,
			creativeCount: data.creativeCount || 0,
		};
	},
};

export const CONTENT_FEED_COLUMNS = [
	CONTENT_FEED_NAME,
	CONTENT_FEED_ID,
	ContentFeedActionsCell,
	CONTENT_FEED_TYPE,
	CONTENT_FEED_ITEMS,
	CONTENT_FEED_LAST_UPDATED,
	CONTENT_FEED_CREATED,
	CONTENT_FEED_ASSIGNED_CREATIVES,
	CONTENT_FEED_AUTO_UPDATES,
];
